import React from "react";
import { FaEdit } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { deleteUser } from "../../../redux/slice/usersSlice";
import DeleteButton from "../common/DeleteButton";
import moment from "moment";

const UserItem = ({ user }) => {
  const navigate = useNavigate();
  const createdAt = new Date(user.createdAt);
  const date = moment(createdAt).format("MMM DD YY, h:mm a");

  const handleEdit = () => {
    navigate(`/admin/edit-user/${user._id}`);
  };

  return (
    <tr className="border-b">
      <td className="px-2 py-4 overflow-clip">
        <span>{user.name}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{user.email}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{user.mobileNumber ? user.mobileNumber : "-"}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{user.role}</span>
      </td>
      <td className="px-2 py-4 overflow-clip">
        <span>{date}</span>
      </td>
      <td className="px-2 py-4 flex gap-4 justify-center text-base">
        <FaEdit onClick={handleEdit} className="text-blue-700 cursor-pointer" />
        <DeleteButton data={user._id} toDispatch={deleteUser} type="User" />
      </td>
    </tr>
  );
};

export default UserItem;
